export default "__VITE_ASSET__O6xjN5fy__"